import { useCallback } from 'react';

import { type Library } from '@air/api/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackInvitedLibraryMember.meta';

export type UseTrackInvitedLibraryMemberParams = {
  library_id: Library['id'];
  library_member_email?: string;
  library_member_role_id?: string;
};

export const useTrackInvitedLibraryMember = () => {
  const { track } = useAnalyticsUtilities();

  const trackInvitedLibraryMember = useCallback(
    (params: UseTrackInvitedLibraryMemberParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackInvitedLibraryMember };
};
